import { useEffect, useState } from 'react'
import { useUser } from '../../../auth'
import { searchYearForAnalytics } from '../../../server/server'
import { readYearAnalyticsAccess, refreshYearAnalyticsAccess, subscribeYearAnalyticsAccess, yearAnalyticsAccessKey } from '../../../auth/yearAnalyticsAccessCache'

export const prefetchYearAnalyticsAccess = (user) => refreshYearAnalyticsAccess(user,
    () => searchYearForAnalytics({ searchText: '', loadedData: 0 }))

// The backend resolves each school's role model. Numeric role IDs are not
// comparable across institutions, and coverage text is not a capability.
export default function useYearAnalyticsAccess() {
    const { user } = useUser()
    const key = yearAnalyticsAccessKey(user)
    const [, rerender] = useState(0)
    useEffect(() => {
        if (!key) return
        const unsubscribe = subscribeYearAnalyticsAccess(key, () => rerender((version) => version + 1))
        prefetchYearAnalyticsAccess(user)
        return unsubscribe
        // The request scope includes the API, user, institution, and role.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key])
    // null means access has not been confirmed yet; false is a confirmed denial.
    return readYearAnalyticsAccess(key)
}
